<template>
    <div class="page">
      <van-pagination
        v-model="currentPage"
        :page-count="countPage"
        mode="simple"
        @change="change"
      ></van-pagination>
    </div>
</template>

<script>
    export default {
        name: '',
        // components:{vanPagination},
        props:['currentPage','countPage'],
        data () {
            return{

            };
        },
        methods:{
            change:function (page) {
                this.$emit("listenToChildEvent",page);
            }
        },
        computed:{
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {
        overflow: hidden;
    }

    .clearfix:before, .clearfix:after {
        clear: both;
        content: " ";
        display: table;
    }
</style>



// WEBPACK FOOTER //
// src/components/Page/Page.vue